import React from 'react';
import { Link } from 'react-router-dom';
/** components **/
import { Layout } from 'components/organisms';
/** styles **/
import s from '../styles/pages/survey-thanks.module.scss';
/** images **/
import ThanksDog from 'assets/images/thanks-dag-02.png';
import ThanksCat from 'assets/images/thanks-cat.png';
import ThanksBird from 'assets/images/thanks-bird.png';
import ThanksInsta from 'assets/images/thanks-insta.png';
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';

export const SurveyThanks: React.FC = () => {
  return (
    <Layout>
      <div className={s.pageContainer}>
        <div className={s.surveyThanksWrapper}>
          {/* メインコンテンツ */}
          <section className={s.mainContent}>
            <div className={s.whiteBox}>
              <img src={ThanksBird} alt="鳥" className={s.birdTop} />
              <h1 className={s.thankYou}>Thank you !!</h1>
              <h2 className={s.mainTitle}>
                ご回答いただき<br />
                ありがとうございます
              </h2>
              <p className={s.text}>
                事業化に向けて<br />
                参考にさせていただきます！
              </p>
              
              <div className={s.textWithCat}>
                <p className={s.text}>
                  まずは都内から。<br />
                  将来的には全国展開をめざして。<br />
                  ぜひ、応援お願いいたします！
                </p>
                <img src={ThanksCat} alt="猫" className={s.catRight} />
              </div>
              
              <img src={ThanksDog} alt="犬と吹き出し" className={s.dogBottom} />
              <Link to="/" className={s.websiteButton}>
                P-man ウェブサイトへGO!!
              </Link>
            </div>
          </section>
        </div>
        
        {/* 写真募集セクション */}
        <section className={s.photoSection}>
          <a
            href="https://mecgroup.app.box.com/f/64012b84a7ba43268b3b120b49b98a37"
            target="_blank"
            rel="noopener noreferrer"
            className={s.photoLink}
          >
            <div className={s.photoContent}>
              <h3 className={s.photoTitle}>
                <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.78282L7.5 13.0412" stroke="#00B66A" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                ペットさんのお写真募集
                <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1.78282L1.5 13.0412" stroke="#00B66A" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </h3>
              <img src={ThanksInsta} alt="ペットさんのお写真" className={s.instaImage} />
              <p className={s.photoText}>
                P-manインスタでご紹介させていただきます!
              </p>
              <div className={s.photoButton}>
                お写真投稿はこちら
              </div>
            </div>
          </a>
        </section>
        
        <div className={s.surveyThanksWrapper}>
          {/* トップに戻るボタン */}
          <div className={s.bottomButton}>
            <Link to="/" className={s.topButton}>
              <BlackCircleArrow className={s.backArrow} />
              トップに戻る
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};